export interface Tenant {
    name: string
    code: string
}

export const TenantModel: Tenant = {
    name: "",
    code: ""
}